/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Trust_TitleInputs */

const en_landing_trust_title = /** @type {(inputs: Landing_Trust_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy-first. EU-native. No compromises.`)
};

const de_landing_trust_title = /** @type {(inputs: Landing_Trust_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenschutz zuerst. EU-nativ. Ohne Kompromisse.`)
};

const fr_landing_trust_title = /** @type {(inputs: Landing_Trust_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vie privée d'abord. Européen de naissance. Aucun compromis.`)
};

const es_landing_trust_title = /** @type {(inputs: Landing_Trust_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacidad primero. Nativo de la UE. Sin compromisos.`)
};

const it_landing_trust_title = /** @type {(inputs: Landing_Trust_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy al primo posto. Nativo UE. Senza compromessi.`)
};

const nl_landing_trust_title = /** @type {(inputs: Landing_Trust_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy-eerst. EU-native. Zonder compromissen.`)
};

const pl_landing_trust_title = /** @type {(inputs: Landing_Trust_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prywatność na pierwszym miejscu. Natywnie europejskie. Bez kompromisów.`)
};

const fi_landing_trust_title = /** @type {(inputs: Landing_Trust_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yksityisyys edellä. EU-natiivi. Ei kompromisseja.`)
};

const da_landing_trust_title = /** @type {(inputs: Landing_Trust_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privatliv først. EU-baseret. Ingen kompromiser.`)
};

const sv_landing_trust_title = /** @type {(inputs: Landing_Trust_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integritet först. EU-native. Inga kompromisser.`)
};

/**
* | output |
* | --- |
* | "Privacy-first. EU-native. No compromises." |
*
* @param {Landing_Trust_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_trust_title = /** @type {((inputs?: Landing_Trust_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Trust_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_trust_title(inputs)
	if (locale === "fr") return fr_landing_trust_title(inputs)
	if (locale === "es") return es_landing_trust_title(inputs)
	if (locale === "it") return it_landing_trust_title(inputs)
	if (locale === "nl") return nl_landing_trust_title(inputs)
	if (locale === "pl") return pl_landing_trust_title(inputs)
	if (locale === "fi") return fi_landing_trust_title(inputs)
	if (locale === "da") return da_landing_trust_title(inputs)
	if (locale === "sv") return sv_landing_trust_title(inputs)
	return en_landing_trust_title(inputs)
});